/**
 * Integration audit log drawer for DP Operator Console.
 */
import { useState, useEffect } from 'react';
import { apiClient } from '../../lib/apiClient';

export default function IntegrationAuditLog({ integrationId, onClose }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await apiClient.get(`/api/dp/integrations/${integrationId}/audit`);
        setLogs(res.data || res || []);
      } catch {
        setLogs([]);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [integrationId]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div className="bg-[var(--aif-bg-surface)] rounded-xl shadow-xl w-full max-w-lg mx-4 p-6 max-h-[80vh] overflow-y-auto"
           onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Audit Log</h2>
          <button onClick={onClose} className="text-[var(--aif-text-muted)] hover:text-[var(--aif-text-primary)]">X</button>
        </div>

        {loading && <p className="text-sm text-[var(--aif-text-muted)]">Loading...</p>}

        {!loading && logs.length === 0 && (
          <p className="text-sm text-[var(--aif-text-muted)]">No audit entries.</p>
        )}

        {!loading && logs.length > 0 && (
          <div className="space-y-3">
            {logs.map(log => (
              <div key={log.id} className="border-b border-[var(--aif-border-subtle)] pb-2">
                <div className="flex justify-between items-baseline">
                  <span className="text-sm font-medium">{log.action}</span>
                  <span className="text-xs text-[var(--aif-text-muted)]">
                    {log.occurred_at ? new Date(log.occurred_at).toLocaleString() : ''}
                  </span>
                </div>
                <div className="text-xs text-[var(--aif-text-muted)]">
                  by {log.actor_type}{log.actor_user_id ? ` (${log.actor_user_id.slice(0, 8)}...)` : ''}
                </div>
                {log.changes && Object.keys(log.changes).length > 0 && (
                  <pre className="text-xs mt-1 bg-[var(--aif-bg-elevated)] p-1 rounded overflow-x-auto">
                    {JSON.stringify(log.changes, null, 2)}
                  </pre>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
